import { render, staticRenderFns } from "./discount-refuse.vue?vue&type=template&id=7b0ba1ac&"
import script from "./discount-refuse.vue?vue&type=script&lang=js&"
export * from "./discount-refuse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports